import React from "react";
import styles from "./Button.module.css";
const Button = (props) => {
  const color = props.color; // first red second none

  if (color === "red") {
    return (
      <a
        className={`${styles.btn} ${styles.colored} ${props.className}`}
        href={props.href}
        target={props.target}
        rel="noreferrer"
      >
        {props.children}
      </a>
    );
  }

  if (color === "black") {
    return (
      <a
        className={`${styles.btn} ${styles.blackk}`}
        href={props.href}
        target={props.target}
        rel="noreferrer"
      >
        {props.children}
      </a>
    );
  }

  return (
    <a
      className={styles.btn}
      href={props.href}
      target={props.target}
      rel="noreferrer"
    >
      {props.children}
    </a>
  );
};

export default Button;
